import React, { ReactElement } from 'react';

type TileProps = React.HTMLAttributes<HTMLDivElement> & {
  title?: string;
  icon?: ReactElement;
  iconClassName?: string;
  iconText?: ReactElement;
};

export const Tile: React.FC<React.PropsWithChildren<TileProps>> = ({
  title,
  icon,
  iconClassName,
  iconText,
  children,
  className,
  ...props
}) => {
  return (
    <div className={`tile text-center ${className}`} {...props}>
      {title && <h5 className="tile-title">{title}</h5>}
      {icon && <div className="tile-icon">{icon}</div>}
      {iconText && <span className="tile-icon-text">{iconText}</span>}
      {children}
    </div>
  );
};
